import { Grid, Tooltip } from "@mui/material";
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { AddButton } from "../bankDetails/components/bankAccountsContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AsnModuleTableContent from "./components/asnModuleTableContent";

function AsnModuleTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Advanced Shipping Notices
          </Grid>
          <Grid item xs={6}>
            <div style={{ textAlign: "right" }}>
              <Tooltip title="Create an ASN">
                <AddButton replace to="/app/asns"></AddButton>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <AsnModuleTableContent />
      </StepperContentHolder>
    </div>
  );
}

export default AsnModuleTable;